import { render, staticRenderFns } from "./Recipes.vue?vue&type=template&id=87e25246&scoped=true"
import script from "./Recipes.vue?vue&type=script&lang=ts"
export * from "./Recipes.vue?vue&type=script&lang=ts"
import style1 from "./Recipes.vue?vue&type=style&index=1&id=87e25246&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e25246",
  null
  
)

export default component.exports